import { FC } from 'react';
import styles from './ReviewCard.module.scss';

interface IReviewCard {
  name: string;
  message: string;
}

const ReviewCard: FC<IReviewCard> = ({ name, message }) => {
  return (
    <div className={styles.reviewCard}>
      <div className={styles.reviewCard__user}>
        <div className={styles.reviewCard__img}></div>
        <div className={styles.reviewCard__info}>
          <p className={styles.reviewCard__name}>{name}</p>
          {/* <p className={styles.reviewCard__date}>01.08.2023</p> */}
        </div>
      </div>
      <div className={styles.reviewCard__txt}>{message}</div>
    </div>
  );
};

export default ReviewCard;
